import React from 'react'

function Loader({ color = 'text-gray-400', size }) {
    // `size` (a Tailwind number, e.g. 6) builds h-6/w-6. When it's omitted we fall
    // back to a fixed pixel size via inline style, so a bare <Loader /> can't
    // stretch to fill (and swallow) its container.
    const sizeClass = size ? `h-${size} w-${size}` : '';
    return (
        <svg className={`animate-spin mx-auto ${sizeClass} ${color}`} style={size ? undefined : { width: '1.5rem', height: '1.5rem' }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
    )
}

export default Loader